export default function getMinAllowedBirthday() {
  const minBirthDate = new Date();
  minBirthDate.setFullYear(minBirthDate.getFullYear() - 100);
  return minBirthDate.toISOString().split('T')[0];
}
